export const setSelectedCompany = (company) => ({
    type: 'SET_SELECTED_COMPANY',
    payload: company
});

export const setSelectedClient = (client) => ({
    type: 'SET_SELECTED_CLIENT',
    payload: client
});

export const setSelectedFY = (fy) => ({
    type: 'SET_SELECTED_FY',
    payload: fy
});

export const setSelectedFolder = (folder) => ({
    type: 'SET_SELECTED_FOLDER',
    payload: folder
});

export const setSelectedQuery = (query) => ({
    type: 'SET_SELECTED_QUERY',
    payload: query
});

export const resetSelections = () => ({
    type: 'RESET_SELECTIONS'
});

export const setSelectedPrimaryClient = (client) => ({
    type: 'SET_SELECTED_PRIMARY_CLIENT',
    payload: client
});